import * as React from 'react';
import ListDayComponent from './calendar-list-day';
import { IAAPDEvent } from '../classes/event';
import { CalendarAppState } from '../classes/redux-states';
import { connect, Dispatch } from 'react-redux';
import { getEvents } from '../redux/actions/calendar-api';

interface StateToProps {
  eventsByDay: any[];
  state: CalendarAppState;
}

interface DispatchToProps {
  getEvents: () => any;
}

type EventListingProps = StateToProps & DispatchToProps;

export class CalendarListViewComponent extends React.Component<EventListingProps, null> {
  constructor(props: EventListingProps) {
    super(props);

    this.props.getEvents();
  }

  render() {
    return (
      <div className="calendar-container-results" >
          <div className="calendar-container-list" >
            <ul className="events-list">
            {
              this.props.eventsByDay.map(day => <ListDayComponent key={this.props.eventsByDay.indexOf(day)} events={day} />)
            }
            </ul>
          </div>
      </div>
    )
  }
}

function mapStateToProps(state: CalendarAppState) {
  return {
    eventsByDay: state.calendarApiModel.eventList || [],
    state: state
  }
}

function mapDispatchToProps(dispatch: Dispatch<CalendarAppState>): DispatchToProps {
  return {
    getEvents: () => dispatch(getEvents(true))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CalendarListViewComponent)



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/components/calendar-list-view.tsx